import { postCustomUrl } from '../index';

export const uploadFileOnURL = (obj) => {
  return postCustomUrl(obj.url, obj.body, true);
};
